"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectionTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
const MultiSelectionTabContent_1 = require("../MultiSelectionTabContent");
const bridge_1 = require("@completeanatomy/bridge");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
function MultiSelectionTab({ className }) {
    const { items, isUndoActive, isRedoActive } = (0, hooks_1.useMultiSelectState)();
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const handleClick = () => {
        navigate('/mode/multiselect-focus');
    };
    const onClickUndo = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.multipleSelectionUndoAction();
    };
    const onClickRedo = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.multipleSelectionRedoAction();
    };
    const onClickExplode = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.isolateAction({ animated: true, activateExplodeIsolate: true });
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleExplodeMode({
            mode: true,
            exitIsolate: true,
            animation: true,
        });
        navigate('/mode/multiselect-focus');
    };
    const multiSelectionTabsButtons = [
        {
            onClick: onClickUndo,
            iconName: ui_1.Icons.Multi_Selection_Undo,
            label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.undo),
            disabled: !isUndoActive,
        },
        {
            onClick: onClickRedo,
            iconName: ui_1.Icons.Multi_Selection_Redo,
            label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.redo),
            disabled: !isRedoActive,
        },
        {
            onClick: onClickExplode,
            iconName: ui_1.Icons.Multi_Selection_Explode,
            label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.multiSelection.explode),
            disabled: items.length < 2,
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'MultiSelectionTab_Container', children: [(0, jsx_runtime_1.jsx)(atoms_1.TabButtonsContainer, { "$isMobile": false, horizontal: true, "data-e2e": 'MultiSelectionTab_TabButtonsContainer', children: multiSelectionTabsButtons.map(({ onClick, iconName, label, disabled }) => ((0, jsx_runtime_1.jsx)(MultiSelectionTabButton, { role: "button", onClick: onClick, iconName: iconName, selected: false, label: label, disabled: disabled, className: className, "data-e2e": 'MultiSelectionTab_MultiSelectionTabButton' }, iconName))) }), (0, jsx_runtime_1.jsx)(MultiSelectionTabContent_1.MultiSelectionTabContent, { onClick: handleClick, "data-e2e": 'MultiSelectionTab_MultiSelectionTabContent', children: items })] }));
}
exports.MultiSelectionTab = MultiSelectionTab;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  overflow: hidden;
  height: 200px;
`;
const MultiSelectionTabButton = (0, styled_components_1.default)(atoms_1.TabButton) `
  opacity: ${({ disabled }) => (disabled ? 0 : 1)};

  fill: ${({ theme }) => theme.textSecondary};
`;
